export default function faqAccordion() {
  const accordionButtons = document.querySelectorAll('.p-faqAccordion__button');

  accordionButtons.forEach(button => {
    button.addEventListener('click', () => {
      const contentId = button.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (content.getAttribute('aria-hidden') === 'true') {
        content.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0';
      }
    });
  });


  const tocButton = document.querySelector('.c-toc__title');
  if (!tocButton) return;

  const contentId = tocButton.getAttribute('aria-controls');
  if (!contentId) return;

  const content = document.getElementById(contentId);
  if (!content) return;

  const contentHeight = content.scrollHeight;
  content.style.maxHeight = contentHeight + 'px'; // 初期状態で開いた状態に設定
  content.setAttribute('aria-hidden', 'false'); // 初期状態で表示されている状態に設定
  tocButton.setAttribute('aria-expanded', 'true'); // 初期状態で展開されている状態に設定

  tocButton.addEventListener('click', () => {
    if (content.getAttribute('aria-hidden') === 'true') {
      content.setAttribute('aria-hidden', 'false');
      tocButton.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = contentHeight + 'px';
    } else {
      content.setAttribute('aria-hidden', 'true');
      tocButton.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
    }
  });

  // const tocButton = document.querySelector('.c-toc__title');
  // tocButton.addEventListener('click', () => {
  //   const contentId = tocButton.getAttribute('aria-controls');
  //   const content = document.getElementById(contentId);

  //   if (content.getAttribute('aria-hidden') === 'true') {
  //     content.setAttribute('aria-hidden', 'false');
  //     tocButton.setAttribute('aria-expanded', 'true');
  //     content.style.maxHeight = content.scrollHeight + 'px';
  //   } else {
  //     content.setAttribute('aria-hidden', 'true');
  //     tocButton.setAttribute('aria-expanded', 'false');
  //     content.style.maxHeight = '0';
  //   }
  // });
}
